import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Category} from "../../models/category";
import {CategoryService} from "../../services/category/category.service";
import {MessagesService} from "../../services/messages/messages.service";

@Component({
    selector: 'app-category-modal',
    templateUrl: './category-modal.component.html',
    styleUrls: ['./category-modal.component.scss']
})
export class CategoryModal implements OnInit {

    @Input() projectId: string;
    @Input() databaseId: string;
    @Input() category: Category;
    @Input() categoriesLength: number;

    categoryForm: FormGroup;
    categoryFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private messagesService: MessagesService,
        private categoriesService: CategoryService,
    ) {
    }

    ngOnInit() {
        this.categoryForm = this.formBuilder.group({
            name: [this.category ? this.category.name || '' : '', [Validators.required]],
        });
    }

    submitCategoryForm() {
        this.categoryFormIsSubmitted = true;

        if (this.categoryForm.invalid) return;

        const category = new Category({
            name : this.categoryForm.controls.name.value,
            order: this.categoriesLength + 1
        });

        this.categoriesService.postCategory(this.projectId, this.databaseId, category)
            .subscribe(
                () => this.messagesService.successToast('Category created.'),
                err => this.messagesService.errorToast(err),
                () => this.activeModal.close(false)
            );
    }
}